module.exports = __webpack_public_path__ + "img/MCSA.3eda70bf.jpg";